import React from "react";
import "./App.css";
import { Invitation, Completed, Home } from "./views";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/events/3rdbirthday/completed">
          <Completed />
        </Route>
        <Route path="/events/3rdbirthday">
          <Invitation />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
